import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Alert } from 'react-bootstrap-5';

import SearchPage from 'components/search_page';
import PropertiesTab from './properties/properties_tab';
import TransferRecordsPortal from 'components/database/transfer_records_portal';
import { enableTransferRecords, toggleAlert } from './store/actions/ui';

export class Research extends React.Component {
  static propTypes = {
    alertMessage: PropTypes.string.isRequired,
    enableTransferRecords: PropTypes.func.isRequired,
    error: PropTypes.bool.isRequired,
    toggleAlert: PropTypes.func.isRequired,
    transferRecordBatch: PropTypes.object,
  };

  handleDismiss = () => {
    this.props.toggleAlert('', false);
  };

  componentDidUpdate(prevProps) {
    const { alertMessage } = this.props;

    if (prevProps.alertMessage !== alertMessage && alertMessage) {
      setTimeout(() => {
        this.handleDismiss();
      }, 6000);
    }
  }

  render() {
    const { alertMessage, error, transferRecordBatch, enableTransferRecords } =
      this.props;

    return (
      <React.Fragment>
        {alertMessage && (
          <Alert
            variant={error ? 'danger' : 'success'}
            onDismiss={this.handleDismiss}
          >
            {alertMessage}
          </Alert>
        )}
        <SearchPage>
          <div className="results-tab-container h-100">
            <PropertiesTab />
          </div>
        </SearchPage>
        <TransferRecordsPortal
          transferRecordBatch={transferRecordBatch}
          onReady={enableTransferRecords}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  alertMessage: state.ui.alertMessage,
  error: state.ui.error,
  transferRecordBatch: state.transfers.batch,
});

const mapDispatchToProps = { enableTransferRecords, toggleAlert };

export default connect(mapStateToProps, mapDispatchToProps)(Research);
